
export const appointmentsData = [
  {
    title: "installation",
    status: "completed",
    statusCode: 1,
    requestNumber: "11106210",
    createdAt: "30 May 2021",
    completedDt: "31 May 2021",
  },
  {
    title: "technical issue",
    status: "cancelled",
    statusCode: 0,
    requestNumber: "11106909",
    createdAt: "30 June 2021",
    cancelledDt: "30 June 2021",
    cancelReason: "I resolved the issue.",
  },
  {
    title: "non-technical",
    status: "completed",
    statusCode: 1,
    requestNumber: "11106211",
    createdAt: "30 May 2021",
    completedDt: "31 May 2021",
  },
  {
    title: "technical issue",
    status: "cancelled",
    statusCode: 0,
    requestNumber: "11106919",
    createdAt: "30 June 2021",
    cancelledDt: "30 June 2021",
    cancelReason: "I resolved the issue.",
  },
  {
    title: "re-installation",
    status: "cancelled",
    statusCode: 0,
    requestNumber: "11106509",
    createdAt: "30 June 2021",
    cancelledDt: "30 June 2021",
    cancelReason: "Technically not possible.",
  },
  {
    title: "PDL conx",
    status: "completed",
    statusCode: 1,
    requestNumber: "11176210",
    createdAt: "30 May 2021",
    completedDt: "31 May 2021",
  },
];